"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.define-property");

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var ThemeContext = react_1.createContext({
  theme: '',
  updateTheme: function updateTheme() {}
});

function ThemeProvider(_a) {
  var value = _a.value,
      children = _a.children;

  var _b = react_1.useState(value),
      theme = _b[0],
      setTheme = _b[1];

  return react_1["default"].createElement(ThemeContext.Provider, {
    value: {
      theme: theme,
      updateTheme: setTheme
    }
  }, react_1["default"].createElement("div", {
    className: "theme-" + theme
  }, children));
}

exports.ThemeProvider = ThemeProvider;

function useTheme() {
  return react_1.useContext(ThemeContext);
}

exports.useTheme = useTheme;
var COLORS = ['primary', 'transparent', 'white', 'black', 'gray', 'red', 'orange', 'yellow', 'green', 'teal', 'blue', 'indigo', 'purple', 'pink'];

function useBackgroundColor(className, hover) {
  if (className) {
    for (var i = 0; i < COLORS.length; i++) {
      if (className.includes("bg-" + COLORS[i])) {
        return className;
      }
    }
  }

  var str = 'bg-primary';
  if (hover) str += ' hover:bg-primary-hover';
  return classnames_1["default"](className, str);
}

exports.useBackgroundColor = useBackgroundColor;

function useTextColor(className, hover) {
  if (className) {
    for (var i = 0; i < COLORS.length; i++) {
      if (className.includes("text-" + COLORS[i])) {
        return className;
      }
    }
  }

  var str = 'text-primary';
  if (hover) str += ' hover:text-primary-hover';
  return classnames_1["default"](className, str);
}

exports.useTextColor = useTextColor;

function useBorderColor(className) {
  if (className) {
    for (var i = 0; i < COLORS.length; i++) {
      if (className.includes("border-" + COLORS[i])) {
        return className;
      }
    }
  }

  var str = 'border-primary';
  return classnames_1["default"](className, str);
}

exports.useBorderColor = useBorderColor;